import { t } from '@lingui/macro';
import PropTypes from 'prop-types';
import React from 'react';

import Checkbox from '@components/common/checkbox/main';

import AccordionSection from './accordionSection';

function OrientationFilter({ orientation, updateFilters }) {
  return (
    <AccordionSection title={t`Orientation`}>
      <div
        className="orientation-options"
        role="group"
        aria-label={t`Orientation`}
      >
        <div className="flex-row">
          <Checkbox
            ariaLabel={t`Horizontal`}
            checked={orientation.indexOf('landscape') > -1}
            datakey="advanced-filter-orientation-landscape"
            label={t`Horizontal`}
            size="sm"
            toggle={() => updateFilters("landscape")}
          />
          <div className="icon-holder">
            <span aria-hidden="true" className="bff-horizontal-orientation" />
          </div>
        </div>
        <div className="flex-row">
          <Checkbox
            ariaLabel={t`Vertical`}
            checked={orientation.indexOf('portrait') > -1}
            datakey="advanced-filter-orientation-portrait"
            label={t`Vertical`}
            size="sm"
            toggle={() => updateFilters("portrait")}
          />
          <div className="icon-holder">
            <span aria-hidden="true" className="bff-vertical-orientation" />
          </div>
        </div>
        <div className="flex-row">
          <Checkbox
            ariaLabel={t`Square`}
            checked={orientation.indexOf('square') > -1}
            datakey="advanced-filter-orientation-square"
            label={t`Square`}
            size="sm"
            toggle={() => updateFilters("square")}
          />
          <div className="icon-holder">
            <span aria-hidden="true" className="bff-square-orientation" />
          </div>
        </div>
        <div className="flex-row">
          <Checkbox
            ariaLabel={t`Panoramic`}
            checked={orientation.indexOf('panorama') > -1}
            datakey="advanced-filter-orientation-panorama"
            label={t`Panoramic`}
            size="sm"
            toggle={() => updateFilters("panorama")}
          />
          <div className="icon-holder">
            <span aria-hidden="true" className="bff-panoramic-orientation" />
          </div>
        </div>
      </div>
    </AccordionSection>
  );
}

OrientationFilter.propTypes = {
  orientation: PropTypes.arrayOf(PropTypes.string).isRequired,
  updateFilters: PropTypes.func.isRequired,
};

export default OrientationFilter;
